import { generatePath } from "react-router-dom";

export const PATH_WORK_LOGS = "/member/work-logs";

export const PATH_WORK_LOGS_EDIT = PATH_WORK_LOGS + "/edit/:workLogId";

export function getPathWorkLogEdit(workLogId: string) {
  return generatePath(PATH_WORK_LOGS_EDIT, { workLogId });
}

// Payee routes
export const PATH_WORK_LOGS_PAYEE = "/member/work-logs/payee";

export const PATH_WORK_LOGS_PAYEE_DETAILS =
  PATH_WORK_LOGS_PAYEE + "/:workLogId";

// Payee dashboard tab routes
export const PATH_WORK_LOGS_PAYEE_TAB_IN_PROGRESS =
  PATH_WORK_LOGS_PAYEE + "/in-progress";
export const PATH_WORK_LOGS_PAYEE_TAB_SUBMITTED =
  PATH_WORK_LOGS_PAYEE + "/submitted";
export const PATH_WORK_LOGS_PAYEE_TAB_APPROVED =
  PATH_WORK_LOGS_PAYEE + "/approved";
export const PATH_WORK_LOGS_PAYEE_TAB_REJECTED =
  PATH_WORK_LOGS_PAYEE + "/rejected";

export function getPathWorkLogPayeeDetails(workLogId: string) {
  return generatePath(PATH_WORK_LOGS_PAYEE_DETAILS, { workLogId });
}

// Payer routes
export const PATH_WORK_LOGS_PAYER = "/member/work-logs/payer";

export const PATH_WORK_LOGS_PAYER_DETAILS =
  PATH_WORK_LOGS_PAYER + "/:workLogId";

export const PATH_WORK_LOGS_PAYER_TAB_IN_PROGRESS =
  PATH_WORK_LOGS_PAYER + "/in-progress";
export const PATH_WORK_LOGS_PAYER_TAB_SUBMITTED =
  PATH_WORK_LOGS_PAYER + "/submitted";

// Payer dashboard tab routes (for workLogReviewWorkflow)
export const PATH_WORK_LOGS_PAYER_TAB_DASHBOARD =
  PATH_WORK_LOGS_PAYER + "/dashboard";
export const PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE =
  PATH_WORK_LOGS_PAYER + "/to-approve";
export const PATH_WORK_LOGS_PAYER_TAB_APPROVED =
  PATH_WORK_LOGS_PAYER + "/approved";
export const PATH_WORK_LOGS_PAYER_TAB_REJECTED =
  PATH_WORK_LOGS_PAYER + "/rejected";

export function getPathWorkLogPayerDetails(workLogId: string) {
  return generatePath(PATH_WORK_LOGS_PAYER_DETAILS, { workLogId });
}
